// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, IsEmail, IsInt, IsNotEmpty, IsOptional, IsString, ValidateNested } from 'class-validator';
import { RoleApiModel } from '../../../../types/models/role.model';
import { DomainApiModel } from '../../../../types/models/domain.model';

class RoleForm implements Pick<RoleApiModel, keyof RoleForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;
}

class DomainForm implements Pick<DomainApiModel, keyof DomainForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;

  @IsString()
  shortName: string;
}

export class UserForm {
  @IsString()
  @IsNotEmpty()
  firstName: string;

  @IsString()
  @IsNotEmpty()
  lastName: string;

  @IsEmail()
  @IsNotEmpty()
  email: string;

  @IsOptional()
  @IsString()
  password?: string;

  @IsArray()
  @ValidateNested({ each: true })
  roles: RoleForm[];

  @IsArray()
  @ValidateNested({ each: true })
  domains: DomainForm[];
}
